const SIGNATURE_TABLE_MARKERS = [
  /contract-signature-space/i,
  /contract-signature-firma-field/i,
  /FIRMA\s+DEL\s+ESTUDIANTE/i,
  /REPRESENTANTE\s+LEGAL/i,
  /Firma:\s*_{3,}/i,
  /{{sistema\.firma_representante}}/i,
];

function isSignatureTable(tableHtml: string): boolean {
  return SIGNATURE_TABLE_MARKERS.some((pattern) => pattern.test(tableHtml));
}

function stripSignatureTables(html: string): string {
  return html.replace(/<table\b[^>]*>[\s\S]*?<\/table>/gi, (table) =>
    isSignatureTable(table) ? '' : table,
  );
}

/**
 * Removes signature blocks from contract HTML for on-screen signing.
 * The student signs in the pad; name/RUT/signature rows belong in the PDF only.
 */
export function stripContractSignatureSectionForSigningView(html: string): string {
  let result = html
    .replace(
      /<p\b[^>]*>\s*<strong>\s*FIRMA\s+Y\s+ACEPTACI[ÓO]N\s*<\/strong>\s*<\/p>\s*/gi,
      '',
    )
    .replace(/<div\b[^>]*class=["'][^"']*contract-signature-firma-field[^"']*["'][^>]*>[\s\S]*?<\/div>/gi, '')
    .replace(/<br>\s*\n?\s*Fecha:\s*[^<\n]*/gi, '');

  result = stripSignatureTables(result);

  result = result.replace(
    /<tr\b[^>]*>\s*<td\b[^>]*>[\s\S]*?<div\b[^>]*contract-signature-space[^>]*>[\s\S]*?<\/div>[\s\S]*?<\/td>[\s\S]*?<\/tr>/gi,
    '',
  );

  result = result.replace(
    /<tr\b[^>]*>\s*<td\b[^>]*>\s*Firma:\s*[_\s]+[\s\S]*?<\/td>[\s\S]*?<\/tr>/gi,
    '',
  );

  return stripContractLegalFooter(result);
}

function stripContractLegalFooter(html: string): string {
  const footerMarker =
    /Documento generado electrónicamente|Ley 19\.799 sobre firma electrónica/i;
  const match = footerMarker.exec(html);
  if (!match || match.index === undefined) return html;

  const before = html.slice(0, match.index);
  const blockStart = before.lastIndexOf('<p');
  if (blockStart >= 0) {
    return html.slice(0, blockStart).trimEnd();
  }

  return before.trimEnd();
}
